export enum DGMigasReportingTabs {
  UNSENT = 'UNSENT',
  SENT = 'SENT',
}